import { AfterViewInit, Component, OnInit, ViewChild, ChangeDetectorRef  } from '@angular/core';
import { MasterService } from 'src/app/services/master.service';
import { CommonService } from 'src/app/services/common.service';
import { Basic } from 'src/app/core/models/basic.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BookComplaintReason } from 'src/app/models/master/book-complaint-reason.model';
import { BookComplaintSubReason } from 'src/app/models/master/book-complaint-sub-reason.model';
import { Subscription } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { ClientSectionComponent } from '../client-section/client-section.component';
import { ClientAddressSectionComponent } from '../client-address-section/client-address-section.component';
import { ClientRepresentativeSectionComponent } from '../client-representative-section/client-representative-section.component';
import { NotificationAddressSectionComponent } from '../notification-address-section/notification-address-section.component';
import Swal from 'sweetalert2'
import { Bill } from 'src/app/models/bill.model'
import { BillService } from 'src/app/services/bill.service';
import { ComplaintClient } from 'src/app/models/complaint/complaint-client.model';
import { ComplaintAddress } from 'src/app/models/complaint/complaint-address.model';
import { ComplaintSimpleAddress } from 'src/app/models/complaint/complaint-simple-address.model';
import { ComplaintClientRepresentative } from 'src/app/models/complaint/complaint-client-representative.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ComplaintBook } from 'src/app/models/complaint/complaint-book.model';
import { ComplaintBookBill } from 'src/app/models/complaint/complaint-book-bill.model';
import { ComplaintBookService } from 'src/app/services/complaint-book.service';
import { MatDialog } from '@angular/material';
import { ComplaintResponseComponent } from '../complaint-response/complaint-response.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplaintSubReason } from 'src/app/models/master/complaint-sub-reason.model';
import { CheckableItem } from 'src/app/core/models/checkable-item.model';
import { BillItem } from 'src/app/models/bill/bill-item.model';
import { MeterContrastAdComponent } from '../meter-contrast-ad/meter-contrast-ad.component';
import { ComplaintService } from 'src/app/services/complaint.service';
import { ClaimsBlocking } from 'src/app/models/complaint/ClaimsBlocking.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment/moment';
import { EmailValidatorService } from 'src/app/services/email-validator.service';
import { EmailNotification } from 'src/app/models/complaint/complaint-email-notification.model';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { ComplaintBill } from 'src/app/models/complaint/complaint-bill.model';
import { ComplaintConcept } from 'src/app/models/complaint/complaint-concept.model';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { MeterReciboDigitalComponent } from '../meter-recibo-digital/meter-recibo-digital.component';
@Component({
  selector: 'app-complaint-2-book',
  templateUrl: './complaint-2.component.html',
  styleUrls: ['./complaint-2.component.scss']
})
export class Complaint2ExternalComponent implements OnInit, AfterViewInit {


  labelNotificacion = '';
  clientFlagPrivacyWebPolitic: string;

  isAcceptTerms: boolean = false;
  /**Hiddens:valida si un elemento sera visualizado o no */
  isHiddenSubReason = false;
  /**Lista de tipos de incidencias */
  typeList: Basic<string>[] = [];
  /**Lista de motivos */
  reasonList: BookComplaintReason[] = [];
  /**Lista de submotivos */
  subReasonList: BookComplaintSubReason[] = [];
  /**Lista de submotivos que necesitan de la sección recibo */
  billSubReasonList: string[] = ['Z104', 'Z118', 'Z120', 'Z133']
  /**Lista de recibos del cliente */
  billList: Bill[] = [];
  /**Es cliente? */
  isClient: boolean = false;
  bandera: boolean;
  botonTipoReclamo: boolean = true;
  /**Mostrar sección de recibo */
  showBillSection: boolean = false;
  formGroup: FormGroup;
  isContrast: string

  urlAWS: string = "";

  textoCorreoCliente: string = '';

  token_temp_ws = "";
  /*Suscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;
  tipoReclamo = "";
  @ViewChild('clientSectionComponent', { read: ClientSectionComponent, static: false })
  public clientSectionComponent: ClientSectionComponent;
  @ViewChild('clientAddressSectionComponent', { read: ClientAddressSectionComponent, static: false })
  public clientAddressSectionComponent: ClientAddressSectionComponent;
  @ViewChild('clientRepresentativeSectionComponent', { read: ClientRepresentativeSectionComponent, static: false })
  public clientRepresentativeSectionComponent: ClientRepresentativeSectionComponent;
  @ViewChild('notificationAddressSectionComponent', { read: NotificationAddressSectionComponent, static: false })
  public notificationAddressSectionComponent: NotificationAddressSectionComponent;

  inputValue: string = '';
  maxLength: number = 550;
  DeshabilitaBotonGuardar: boolean = false;

  TieneSuministro: boolean = false;

  recibirTextoCorreoCliente(texto: string) {
    if (this.formGroup.get('isNotification').value == 'si') {
      if (this.formGroup.get('notificacionInput')) {
        this.formGroup.get('notificacionInput').setValue(texto);
      }
    }
  }

  constructor(private cdRef: ChangeDetectorRef,
    private masterService: MasterService, private formBuilder: FormBuilder,
    private commonService: CommonService,
    private accountService: AccountService,
    private billService: BillService,
    private authService: AuthService,
    private complaintBookService: ComplaintBookService,
    private matDialog: MatDialog,
    private router: Router,
    private routerActivate: ActivatedRoute,
    private modal: NgbModal,
    private complaintService: ComplaintService,

    private environmentService: EnvironmentService,
    private emailValidatorService: EmailValidatorService,
    private reCaptchaV3Service: ReCaptchaV3Service
  ) {


  }
  get f() { return this.formGroup.controls; }


  ngOnInit() {




    this.isClient = true;
    this.bandera = false;
    this.botonTipoReclamo = true;

    window.scrollTo(0, 0);


    this.listComplaintReasons();
    this.fillYearList();
    this.createForm();
    this.listBookComplaintTypes();

    const TOKEN = this.routerActivate.snapshot.queryParamMap.get('token');
    this.token_temp_ws = TOKEN;
    this.isClient = this.token_temp_ws ? true : false

    this.formGroup.get('reason').clearValidators();   
    this.formGroup.get('subReason').clearValidators();

    this.router.navigate(['/ofivirtual/reclamos-external'])
    if (this.isClient)
      this.authService.setUser(this.token_temp_ws)

  }

  ngAfterViewInit() {
    if (this.isClient) {

      this.accountService.listExternal(this.token_temp_ws).subscribe(response => {
        if (response.valid) {
          this.authService.setAccountListToMemory(response.data);
          this.commonService.announceAccountListLoaded(response.data);
        }
      })

      this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
        this.getBasicData(account.clientCode);
      });

    } else {

      this.getBasicDataWithoutClient();


    }

  }
  ngOnDestroy() {
    this.accountSelectedSubscription.unsubscribe();
  }

  closeModal(modal) {
    modal.dismiss();
    this.clearBoxes();
    this.difRoundedList = [];
    this.checkBoxList = [];
  }
  onClickTipo(tipo) {

    if (this.isClient) {

      this.formGroup.get('bill').get('month').clearValidators();
      this.formGroup.get('bill').get('month').updateValueAndValidity();
      this.formGroup.get('bill').get('year').clearValidators();
      this.formGroup.get('bill').get('year').updateValueAndValidity();
      this.formGroup.get('bill').get('number').clearValidators();
      this.formGroup.get('bill').get('number').updateValueAndValidity();


      this.formGroup.get('bill').get('month').setValue('')
      this.formGroup.get('bill').get('year').setValue('')
      this.formGroup.get('bill').get('number').setValue('')

      this.showBillSection = false;
      this.cleanBillSection();

    }

    if (tipo == this.tipoReclamo) {

      this.tipoReclamo = '';
      this.formGroup.get('reason').setValue('')
      this.formGroup.get('subReason').setValue('')
      this.formGroup.get('description_osi').setValue('')
      this.formGroup.get('type').setValue('')
      this.formGroup.get('description').setValue('')


    } else {
      this.tipoReclamo = tipo;
      this.formGroup.get('type').setValue('')
      this.formGroup.get('reason').setValue('')
      this.formGroup.get('subReason').setValue('')

      if (tipo == 'ZREG') {
        this.formGroup.get('type').clearValidators();
        this.formGroup.get('type').updateValueAndValidity();
        this.formGroup.get('description').clearValidators();
        this.formGroup.get('description').updateValueAndValidity();

        this.formGroup.get('type').setValue('')
        this.formGroup.get('description').setValue('')

        this.formGroup.get('description_osi').setValidators([Validators.required, Validators.maxLength(550)]);
        this.formGroup.get('description_osi').updateValueAndValidity()
        this.subReasonList = []
        this.reasonList = [];

        this.botonTipoReclamo = true;

        this.formGroup.get('reason').setValidators([Validators.required]);
        this.formGroup.get('reason').updateValueAndValidity();        
        this.formGroup.get('subReason').setValidators([Validators.required]);
        this.formGroup.get('subReason').updateValueAndValidity();

      } else if (tipo == 'ZRIN') {
        this.subReasonListOsi = []

        this.formGroup.get('description_osi').clearValidators();
        this.formGroup.get('description_osi').updateValueAndValidity();
        this.formGroup.get('description_osi').setValue('')

        this.formGroup.get('type').setValidators([Validators.required]);
        this.formGroup.get('type').updateValueAndValidity()
        this.formGroup.get('description').setValidators([Validators.required, Validators.maxLength(550)]);
        this.formGroup.get('description').updateValueAndValidity();

        this.formGroup.get('reason').clearValidators();
        this.formGroup.get('subReason').clearValidators();

        this.botonTipoReclamo = false;

      }

    }

  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      //isAcceptTerms: ['', [Validators.required]],
      type: ['', [Validators.required]],
      reason: ['', [Validators.required]],
      subReason: ['', [Validators.required]],
      description: ['', [Validators.required]],
      isNotification: ['', Validators.required],
      //descripcionTipoBien: ['', Validators.required],
      //tipoBien: ['', Validators.required],
      bill: this.formBuilder.group({
        number: [],
        amount: [{ value: '', disabled: true }],
        month: [],
        year: []
      }),
      description_osi: ["", [Validators.required, Validators.maxLength(550)]],
    })
  }
  getBasicDataWithoutClient() {

    this.formGroup.addControl('client', this.clientSectionComponent.formGroup);
    this.formGroup.addControl('clientAddress', this.clientAddressSectionComponent.formGroup);
    //SIN CLIENTE
    this.formGroup.addControl('representative', this.clientRepresentativeSectionComponent.formGroup);
    if (this.formGroup.get('clientAddress')){
      this.formGroup.get('clientAddress').valueChanges.subscribe((value) => {
        this.clientAddressSectionComponent.concatStreetAddress()
        if (this.formGroup.get('notificacionInput')) {

          if (this.formGroup.get('isNotification').value == 'no') {

            this.formGroup.get('notificacionInput').setValue(this.clientAddressSectionComponent.ConcatAdress)
          }
        }
      });
    }

  }

  getBasicData(clientCode: string) {
    this.accountService.getBasicData(clientCode).subscribe(response => {
      
      this.TieneSuministro = response.data.tieneDirSuministro;
      this.cdRef.detectChanges();

      this.formGroup.addControl('client', this.clientSectionComponent.formGroup);

      if (!this.TieneSuministro){
        this.formGroup.addControl('clientAddress', this.clientAddressSectionComponent.formGroup);
        //ToDo: Valida datos
        this.clientAddressSectionComponent.fillForm(response.data);
      }else{
        this.formGroup.addControl('notificationAddress', this.notificationAddressSectionComponent.formGroup);
        this.notificationAddressSectionComponent.fillForm(response.data);

        this.formGroup.addControl('clientAddress', this.clientAddressSectionComponent.formGroup);
        this.clientAddressSectionComponent.fillForm(response.data);

        this.clientAddressSectionComponent.formGroup.disable();
      }

      this.formGroup.addControl('representative', this.clientRepresentativeSectionComponent.formGroup);
      this.clientSectionComponent.fillForm(response.data);

      this.cleanBillSection();

      if (this.isClient && !this.TieneSuministro) {
        this.formGroup.get('clientAddress').valueChanges.subscribe((value) => {
          this.clientAddressSectionComponent.concatStreetAddress()
          if (this.formGroup.get('notificacionInput')) {
    
            if (this.formGroup.get('isNotification').value == 'no') {
    
              this.formGroup.get('notificacionInput').setValue(this.clientAddressSectionComponent.ConcatAdress)
            }
          }
        });
      }
    });
    this.billService.listForComplaintBookExternal(clientCode, this.token_temp_ws).subscribe(response => {
      this.billList = response.data;
    })
  }


  listBookComplaintTypes() {
    this.masterService.listBookComplaintTypes().subscribe(response => {
      this.typeList = response.data;
    })
  }
  listBookComplaintReasons() {
    this.masterService.listBookComplaintReasons(this.formGroup.get('type').value).subscribe(response => {

      if (this.isClient) {
        this.reasonList = response.data;
      } else {
        this.subReasonList = [];

        if (this.formGroup.get('type').value == 'T002') {
          const ARRAY_EQUAL = ['M006', 'M005', 'M009']
          this.reasonList = response.data.filter(x => ARRAY_EQUAL.includes(x.code))
        } else if (this.formGroup.get('type').value == 'T001') {

          const ARRAY_EQUAL = ['M003']
          this.reasonList = response.data.filter(x => ARRAY_EQUAL.includes(x.code))
        }


      }

      this.formGroup.get('reason').patchValue(null);
      this.formGroup.get('subReason').patchValue(null);
      this.subReasonChanged();
    })
  }
  listBookComplaintSubReasons() {
    const idReason = this.formGroup.get('reason').value;
    this.isHiddenSubReason = false;
    this.formGroup.get('subReason').clearValidators();
    this.formGroup.get('subReason').updateValueAndValidity();

    if (idReason == "M002") {
      this.formGroup.get('subReason').setValue("");
      this.isHiddenSubReason = true;
    } else if (idReason == "M010") {
      this.formGroup.get('subReason').setValue("");
      this.isHiddenSubReason = true;
    } else {
      this.formGroup.get('subReason').setValidators([Validators.required]);
      this.formGroup.get('subReason').updateValueAndValidity();

      this.masterService.listBookComplaintSubReasons(idReason).subscribe(response => {
        this.subReasonList = response.data;
        this.formGroup.get('subReason').patchValue(null);
        this.subReasonChanged();
      })
    }

  }
  subReasonChanged() {
    this.showBillSection = this.isClient && this.billSubReasonList.includes(this.formGroup.get('subReason').value);
    if (this.showBillSection) this.cleanBillSection();

    if (!this.isClient) {

      if (this.formGroup.get('type').value == 'T001') {
        const ARRAY_EQUAL = ['Z113', 'Z116']
        this.subReasonList = this.subReasonList.filter((x: any) => ARRAY_EQUAL.includes(x.code))
      }
    }
  }
  cleanBillSection() {
    this.formGroup.get('bill').patchValue({
      number: null,
      amount: null
    })
  }
  billSelected() {
    this.billList.filter(x => x.number == this.formGroup.get('bill').get('number').value)
      .map(bill => this.formGroup.get('bill').get('amount').patchValue(bill.dueAmount))
  }

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  async save() {

    try {

      if (this.formGroup.valid) {
        Swal.fire({
          title: 'Aviso',
          text: '¿Está seguro de registrar el reclamo con los datos ingresados?',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sí',
          cancelButtonColor: '#d33',
          cancelButtonText: 'No'
        }).then(async (result) => {
          if (result.value) {
            let complaint = this.buildBookComplaintObject();

            if (this.adjuntosevi != undefined) {
              this.complaintService.addFileComplaints({
                ClientCode: complaint.client.code,
                fileName: this.adjuntosevi.name,
                Base64Image: (await this.toBase64(this.adjuntosevi) as string)
              }).subscribe(
                async responseAWS => {
                  this.urlAWS = responseAWS.data.urlAmazon;
                  if (this.urlAWS != null) {
                    complaint.description += " - URLEvidencia: " + this.urlAWS;
                  }

                  let response = null;
                  if (this.isClient) {
                    this.complaintBookService.AddV2(complaint, this.token_temp_ws).subscribe({
                      next: (response) => {
                        this.responseReclamoAddv2(response);
                      },
                      error: (error) => {
                        this.DeshabilitaBotonGuardar = true;
                      }
                    });

                  } else {
                    this.reCaptchaV3Service.execute('importantAction')
                      .subscribe(async (token) => {
                        console.log(token);
                        // Maneja el token de reCAPTCHA aquí
                        this.complaintBookService.AddV2Captcha(complaint, token).subscribe({
                          next: (response) => {
                            this.responseReclamoAddv2(response);
                          },
                          error: (error) => {
                            this.DeshabilitaBotonGuardar = true;
                          }
                        });
                      });
                  }


                })
            } else {

              let response = null;
              if (this.isClient) {

                this.complaintBookService.AddV2(complaint, this.token_temp_ws).subscribe({
                  next: (response) => {
                    this.responseComplaintAddv2WithoutFile(response);
                  },
                  error: (error) => {
                    this.DeshabilitaBotonGuardar = true;
                  }
                });
              } else {
                this.reCaptchaV3Service.execute('importantAction')
                  .subscribe(async (token) => {
                    // Maneja el token de reCAPTCHA aquí
                    console.log(token);

                    this.complaintBookService.AddV2Captcha(complaint, token).subscribe({
                      next: (response) => {
                        this.responseComplaintAddv2WithoutFile(response);
                      },
                      error: (error) => {
                        this.DeshabilitaBotonGuardar = true;
                      }
                    });
                  });
              }
            }

          }
        })

      } else {
        this.formGroup.markAllAsTouched();
        const errorHtml = await this.commonService.buildErrorHtml(this.formGroup);
        Swal.fire({
          icon: 'warning',
          html: errorHtml
        });
      }

    } catch (error) {

      this.DeshabilitaBotonGuardar = true;

      Swal.fire({
        icon: 'warning',
        html: `<h2>Error</h2>
                    <br />
                    <p>`+ "Ocurrio un error al intentar guardar la información" + `</p>`,
        confirmButtonText: 'Aceptar'

      });
    }

  }
  //sin archivo
  responseReclamoAddv2(response: any) {
    if (response.valid) {
      this.matDialog.open(ComplaintResponseComponent, {
        disableClose: true,
        data: {
          complaintNumber: response.data.complaintNumber,
          operationDateTime: new Date(response.data.operationDateTime.toString()),
          operationId: response.data.operationId,
          mode: 'complaintBookExternal',
          isClient: this.isClient,
          isComplaintExternal: true
        }
      })
    }
    else {
      if (response.message.startsWith("sesion")) {

        this.DeshabilitaBotonGuardar = true;

        this.formGroup.markAllAsTouched();
        Swal.fire({
          icon: 'warning',
          html: `<h2>Información</h2>
                  <br />
                  <p>No puede Registrar más de un reclamo por sesión</p>`,
          confirmButtonText: 'Aceptar'
        }).then(t => {

        });

      }
      else if (response.message.startsWith("ERRORPDF"))
      {
        this.DeshabilitaBotonGuardar = true;
        Swal.fire('Aviso', 'Ocurrio un error al intentar guardar la información.', 'warning').finally(() => {
          //
        });
      }
      else if (response.message.startsWith("ERRORCORREO"))
      {
        this.DeshabilitaBotonGuardar = true;
        Swal.fire('Aviso', 'Ocurrio un error al intentar guardar la información.', 'warning').finally(() => {
          //
        });
      }
      else {
        //this.DeshabilitaBotonGuardar = true;

        this.formGroup.markAllAsTouched();
        Swal.fire({
          icon: 'warning',
          html: `<h2>Error</h2>
                      <br />
                      <p>`+ response.message + `</p>`,
          confirmButtonText: 'Aceptar'

        });
      }
    }


  }

  //con archivo
  responseComplaintAddv2WithoutFile(response: any) {

    if (response.valid) {
      this.matDialog.open(ComplaintResponseComponent, {
        disableClose: true,
        data: {
          complaintNumber: response.data.complaintNumber,
          operationDateTime: new Date(response.data.operationDateTime.toString()),
          operationId: response.data.operationId,
          mode: 'complaintBookExternal',
          isClient: this.isClient,
          isComplaintExternal: true
        }
      })
    }
    else {
      if (response.message.startsWith("sesion")) {

        this.DeshabilitaBotonGuardar = true;

        this.formGroup.markAllAsTouched();
        Swal.fire({
          icon: 'warning',
          html: `<h2>Información</h2>
                  <br />
                  <p>No puede Registrar más de un reclamo por sesión</p>`,
          confirmButtonText: 'Aceptar'
        }).then(t => {

        });

      }
      else if (response.message.startsWith("ERRORPDF"))
        {
          this.DeshabilitaBotonGuardar = true;
          Swal.fire('Aviso', 'Ocurrio un error al intentar guardar la información.', 'warning').finally(() => {
            //
          });
        }
        else if (response.message.startsWith("ERRORCORREO"))
        {
          this.DeshabilitaBotonGuardar = true;
          Swal.fire('Aviso', 'Ocurrio un error al intentar guardar la información.', 'warning').finally(() => {
            //
          });
        }
        else {
          //this.DeshabilitaBotonGuardar = true;
          this.formGroup.markAllAsTouched();
          Swal.fire({
            icon: 'warning',
            html: `<h2>Error</h2>
                        <br />
                        <p>`+ response.message + `</p>`,
            confirmButtonText: 'Aceptar'

          });
      }
    }

  }
  buildBookComplaintObject() {
    let complaint = new ComplaintBook();
    
    complaint.tipoBien = this.formGroup.get('tipoBien') ? this.formGroup.get('tipoBien').value : null;
    complaint.descripcionTipoBien = this.formGroup.get('descripcionTipoBien') ? this.formGroup.get('descripcionTipoBien').value : null;


    complaint.indicadorTitular = !this.isClient ? "04" : "01";

    if (this.formGroup.get('isNotification').value == 'si') {
      complaint.notificacionInput = this.formGroup.get('notificacionInput') ? this.formGroup.get('notificacionInput').value : null;
    }
    complaint.client = new ComplaintClient();
    complaint.client.code = this.formGroup.get('client').get('code').value;
    complaint.client.name = this.formGroup.get('client').get('name').value;
    complaint.client.lastName = this.formGroup.get('client').get('lastName').value;
    complaint.client.documentType = this.formGroup.get('client').get('documentType').value;
    complaint.client.documentNumber = this.formGroup.get('client').get('documentNumber').value;
    complaint.client.homePhone = this.formGroup.get('client').get('homePhone').value;
    complaint.client.cellPhone = this.formGroup.get('client').get('cellPhone').value;
    //complaint.client.emailAddress = this.formGroup.get('client').get('email').value ? this.formGroup.get('client').get('email').value : this.authService.getUserWithToken(this.token_temp_ws).emailAddress;
    if (this.formGroup.get('client').get('email').value){
      complaint.client.emailAddress = this.formGroup.get('client').get('email').value;
    }else{
      if (this.isClient == true) {
        complaint.client.emailAddress = this.authService.getUserWithToken(this.token_temp_ws).emailAddress;
      }
    }

    // complaint.client.type = this.formGroup.get('client').get('type').value;

    if (this.isClient == true) {
      complaint.client.type = this.formGroup.get('client').get('type').value;
      complaint.indicadorTitular = '01';
    }
    else {
      complaint.client.type = this.formGroup.get('client').get('typeNoClient').value;
    }


    complaint.client.interlocutorId = this.formGroup.get('client').get('interlocutorId').value;
    complaint.client.installationNumber = this.formGroup.get('client').get('installationNumber').value;
    complaint.clientAddress = new ComplaintAddress();

    if ((this.isClient && this.TieneSuministro) || !this.isClient){
      complaint.clientAddress.streetType = this.formGroup.get('clientAddress').get('streetType').value;
      complaint.clientAddress.streetDescription = this.formGroup.get('clientAddress').get('streetDescription').value;
      complaint.clientAddress.streetNumber = this.formGroup.get('clientAddress').get('streetNumber').value;
      complaint.clientAddress.buildingType = this.formGroup.get('clientAddress').get('buildingType').value;
      complaint.clientAddress.buildingDescription = this.formGroup.get('clientAddress').get('buildingDescription').value;
      complaint.clientAddress.interiorType = this.formGroup.get('clientAddress').get('interiorType').value;
      complaint.clientAddress.interiorDescription = this.formGroup.get('clientAddress').get('interiorDescription').value;
      complaint.clientAddress.physicalGroupingType = this.formGroup.get('clientAddress').get('physicalGroupingType').value;
      complaint.clientAddress.physicalGroupingDescription = this.formGroup.get('clientAddress').get('physicalGroupingDescription').value;
      complaint.clientAddress.virtualGroupingType = this.formGroup.get('clientAddress').get('virtualGroupingType').value;
      complaint.clientAddress.virtualGroupingDescription = this.formGroup.get('clientAddress').get('virtualGroupingDescription').value;
      complaint.clientAddress.block = this.formGroup.get('clientAddress').get('block').value;
      complaint.clientAddress.lot = this.formGroup.get('clientAddress').get('lot').value;
      complaint.clientAddress.districtCode = this.formGroup.get('clientAddress').get('districtCode').value;
      complaint.clientAddress.provinceCode = this.formGroup.get('clientAddress').get('provinceCode').value;
      complaint.clientAddress.departmentCode = this.formGroup.get('clientAddress').get('departmentCode').value;
      complaint.clientAddress.region = this.formGroup.get('clientAddress').get('region').value;
      complaint.clientAddress.postalCode = this.formGroup.get('clientAddress').get('postalCode').value;
    }

    if (this.isClient && this.TieneSuministro) {
      complaint.firstNotificationAddress = this.formGroup.get('notificationAddress').get('firstNotificationAddress').value;

      if (this.formGroup.get('notificationAddress').get('includeSecondNotificationAddress').value == true) {
        complaint.secondNotificationAddress = new ComplaintSimpleAddress();
        complaint.secondNotificationAddress.description = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('description').value;
        complaint.secondNotificationAddress.districtCode = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('districtCode').value;
        complaint.secondNotificationAddress.provinceCode = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('provinceCode').value;
        complaint.secondNotificationAddress.departmentCode = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('departmentCode').value;
        complaint.secondNotificationAddress.reference = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('reference').value;
      }
    }


    if (this.formGroup.get('representative').get('includeRepresentativeSection').value == true) {
      complaint.clientRepresentative = new ComplaintClientRepresentative();
      complaint.clientRepresentative.name = this.formGroup.get('representative').get('data').get('name').value;
      complaint.clientRepresentative.lastName = this.formGroup.get('representative').get('data').get('lastName').value;
      complaint.clientRepresentative.documentNumber = this.formGroup.get('representative').get('data').get('documentNumber').value;
      complaint.clientRepresentative.documentType = this.formGroup.get('representative').get('data').get('documentType').value;
      complaint.clientRepresentative.homePhone = this.formGroup.get('representative').get('data').get('homePhone').value;
      complaint.clientRepresentative.cellPhone = this.formGroup.get('representative').get('data').get('cellPhone').value;
      complaint.clientRepresentative.emailAddress = this.formGroup.get('representative').get('data').get('email').value;
      complaint.clientRepresentative.relationshipType = this.formGroup.get('representative').get('data').get('relationshipType').value;
      complaint.indicadorTitular = complaint.clientRepresentative.relationshipType;
    }

    complaint.subReasonCode = this.formGroup.get('subReason').value;
    complaint.reasonCode = this.formGroup.get('reason').value;
    //OSIG
    if (this.tipoReclamo == 'ZREG') {
      complaint.motivo = this.reasonListOsi.find(x => x.code == this.formGroup.get('reason').value).description;
      complaint.subMotivo = (this.subReasonListOsi.find((x: any) => x.code == this.formGroup.get('subReason').value) as any).description;
    }
    else {
      const FIND_MOTIVO = (this.reasonList.find((x: any) => x.code == this.formGroup.get('reason').value) as any);
      complaint.motivo = FIND_MOTIVO ? FIND_MOTIVO.description : "";
      //complaint.motivo = this.reasonList.find(x => x.code == this.formGroup.get('reason').value).description;
      const FIND_SUBMOTIVO = (this.subReasonList.find((x: any) => x.code == this.formGroup.get('subReason').value) as any);
      complaint.subMotivo = FIND_SUBMOTIVO ? FIND_SUBMOTIVO.description : "";


    }
    //
    complaint.isNotification = this.formGroup.get('isNotification').value
    complaint.notificacionInput = this.formGroup.get('notificacionInput').value


    let tipoReclamo_aux = this.tipoReclamo;
    if (this.tipoReclamo != 'ZREG') {

      if (this.tipoReclamo == 'ZRIN' && this.formGroup.get('type').value == 'T001') {
        tipoReclamo_aux = 'ZRIN'
      } else if (this.tipoReclamo == 'ZRIN' && this.formGroup.get('type').value == 'T002') {
        tipoReclamo_aux = 'ZQIN'
      }

    }
    complaint.type = tipoReclamo_aux;

    complaint.description = this.formGroup.get('description').value ? this.formGroup.get('description').value
      : this.formGroup.get('description_osi').value;
    if (this.showBillSection && this.tipoReclamo == 'ZRIN') {
      let bill = new ComplaintBill();
      bill.number = this.formGroup.get('bill').get('number').value;
      bill.currency = 'PEN';
      bill.totalAmount = this.formGroup.get('bill').get('amount').value.toString();
      complaint.billList = [{ ...bill }];
    } else
      if (this.showBillSection && this.tipoReclamo == 'ZREG') {


        const bill = new ComplaintBill();
        bill.number = this.formGroup.get('bill').get('number').value;
        bill.period = this.monthList.find(x => x.code === this.formGroup.get('bill').get('month').value).description + ' ' + this.formGroup.get('bill').get('year').value;
        bill.currency = 'PEN';
        // let totalAmount = 0;
        // bill.itemList = this.billItemList.filter(x => x.checked)
        //   .map((item) => {
        //     totalAmount = totalAmount + parseFloat(item.data.amount);
        //     return item.data.formattedValue;
        //   });

        let prepare: any = [];
        for (let i = 0; i < this.listToSend.length; i++) {
          prepare.push(this.listToSend[i].Import)
        }
        let totalAmount = prepare.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
        let rounded = parseFloat(totalAmount).toFixed(2);

        bill.totalAmount = rounded.toString();
        complaint.billList = [bill];
        const conceptBlocking = new ComplaintConcept();
        conceptBlocking.InterloculorComercial = "0";
        conceptBlocking.NroDocumentoOficial = "0";
        conceptBlocking.Anno = "0";
        conceptBlocking.Mes = "0";
        conceptBlocking.FechaEmision = "0";
        conceptBlocking.FechaVencimiento = "0";
        conceptBlocking.CodConcepto = "0";
        conceptBlocking.DesConcepto = "0";
        conceptBlocking.Importe = "0";

        let list: string[] = [];
        for (let i = 0; i < this.listToSend.length; i++) {
          list.push(this.listToSend[i].Locutor
            + "||" + this.listToSend[i].documentNumber
            + "||" + this.listToSend[i].Year
            + "||" + this.listToSend[i].Month
            + "||" + this.listToSend[i].Date
            + "||" + this.listToSend[i].DateHist
            + "||" + this.listToSend[i].ConceptCode
            + "||" + this.listToSend[i].DesConcept
            + "||" + this.listToSend[i].Import
            + "||" + this.listToSend[i].Moneda);
        }

        conceptBlocking.itemList = list;

        complaint.ComplaintConcepto = [conceptBlocking];

      }

    complaint.emailAddressNotification = new EmailNotification();
    if (this.formGroup.get('isNotification').value == 'si') {

      complaint.emailAddressNotification.indContrastacion = this.contrastConfirm == true ? this.isContrast = "SI" : this.isContrast = "NO";
      complaint.emailAddressNotification.operRegLectura = "0";
      complaint.emailAddressNotification.indNotifElectronica = "SI";
      complaint.emailAddressNotification.emailNotifElec = this.formGroup.get('notificacionInput').value;

    } else {
      complaint.emailAddressNotification.indContrastacion = this.contrastConfirm == true ? this.isContrast = "SI" : this.isContrast = "NO";
      complaint.emailAddressNotification.indNotifElectronica = "NO";
      complaint.emailAddressNotification.emailNotifElec = this.formGroup.get('notificacionInput').value;
    }
    return complaint;
  }


  public emailUser: string;
  public notifyMessage: string;
  public back: boolean;
  public send: boolean;
  aceptaCorreo: string;
  isEmailNotificaction: string;
  public hideNextButton: boolean = true;
  public messageNotificationIcon: boolean = true;
  public emailValid: string;
  public emailModal: any;

  public fileNotification: any;
  adjuntosevi: File = undefined;

  handleFileReclamo(event: any) {
    if (event.target.files.item(0) != undefined) {
      this.adjuntosevi = event.target.files.item(0);

      let nameFile = this.adjuntosevi.name;
      this.fileNotification = "Ha cargado el siguiente archivo: " + nameFile;
    }
    else {
      this.fileNotification = "Tiene un archivo cargado.";
    }
  }

  onChangePrivacidad(event) {

    if (!event.checked) {

      this.formGroup.get('isAcceptTerms').setValue('')
    }

  }
  onItemChange(value) {
    if (this.formGroup.get('notificacionInput')) {
      this.formGroup.get('notificacionInput').clearValidators();
      this.formGroup.get('notificacionInput').updateValueAndValidity();
      this.formGroup.get('notificacionInput').setValue('');

      this.formGroup.get('notificacionInput').enable();
    } else {
      this.formGroup.setControl('notificacionInput', this.formBuilder.control(''));
    }

    if (value == 'SI') {
      this.labelNotificacion = 'Correo electrónico'

      this.formGroup.get('notificacionInput').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]);
      this.formGroup.get('notificacionInput').updateValueAndValidity();

      this.formGroup.get('client').get('email').clearValidators();
      this.formGroup.get('client').get('email').setValidators([Validators.required, Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]);
      this.formGroup.get('client').get('email').updateValueAndValidity();

      this.formGroup.get('notificacionInput').setValue(this.formGroup.get('client').get('email').value)

      if(this.isClient)
      {
        this.formGroup.get('notificacionInput').enable();
      }else{
        this.formGroup.get('notificacionInput').disable();
      }

      this.formGroup.get('clientAddress').get('streetNumber').clearValidators();
      this.formGroup.get('clientAddress').get('streetNumber').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('streetType').clearValidators();
      this.formGroup.get('clientAddress').get('streetType').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('streetDescription').clearValidators();
      this.formGroup.get('clientAddress').get('streetDescription').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('departmentCode').clearValidators();
      this.formGroup.get('clientAddress').get('departmentCode').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('provinceCode').clearValidators();
      this.formGroup.get('clientAddress').get('provinceCode').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('districtCode').clearValidators();
      this.formGroup.get('clientAddress').get('districtCode').updateValueAndValidity();

    }
    else if (value == "NO" && this.isClient) {

      this.labelNotificacion = 'Dirección'

      if (this.TieneSuministro){
        this.formGroup.get('notificacionInput').setValue(this.notificationAddressSectionComponent.addressConcat());
      }else{
        this.clientAddressSectionComponent.concatStreetAddress();
        this.formGroup.get('notificacionInput').setValue(this.clientAddressSectionComponent.ConcatAdress);
      }
      
      this.formGroup.get('notificacionInput').disable();

      this.formGroup.get('client').get('email').clearValidators();
      this.formGroup.get('client').get('email').setValidators([Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]);
      this.formGroup.get('client').get('email').updateValueAndValidity();

      this.formGroup.get('clientAddress').get('streetNumber').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('streetNumber').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('streetType').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('streetType').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('streetDescription').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('streetDescription').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('departmentCode').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('departmentCode').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('provinceCode').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('provinceCode').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('districtCode').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('districtCode').updateValueAndValidity();

    } else if (value == "NO" && !this.isClient) {

      this.clientAddressSectionComponent.concatStreetAddress();

      this.labelNotificacion = 'Dirección'
      this.formGroup.get('notificacionInput').setValue(this.clientAddressSectionComponent.ConcatAdress)
      this.formGroup.get('notificacionInput').disable();

      this.formGroup.get('client').get('email').clearValidators();
      this.formGroup.get('client').get('email').setValidators([Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]);
      this.formGroup.get('client').get('email').updateValueAndValidity();

      this.formGroup.get('clientAddress').get('streetNumber').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('streetNumber').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('streetType').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('streetType').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('streetDescription').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('streetDescription').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('departmentCode').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('departmentCode').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('provinceCode').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('provinceCode').updateValueAndValidity();
      this.formGroup.get('clientAddress').get('districtCode').setValidators([Validators.required]);
      this.formGroup.get('clientAddress').get('districtCode').updateValueAndValidity();

    } else {
      this.labelNotificacion = ''
    }


  }


  async correo() {
    if (this.isClient == false) {
      this.emailModal = this.formGroup.get('client').get('email').value;
    }
    var regex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    Swal.fire({
      title: 'Correo de notificación',
      input: 'text',
      inputValue: this.emailModal,
      showCancelButton: true,
      cancelButtonColor: "#F44336",
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
      confirmButtonColor: "#00a1de ",
      inputPlaceholder: "Correo para la notificación",
      allowOutsideClick: false
    }).then((result) => {
      if (result.value) {
        if (regex.test(result.value) == false) {
          // this.spinner.hide();
          this.messageNotificationIcon = true;
          Swal.fire(
            {
              title: 'Correo de notificación',
              text: 'Correo electrónico inválido',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#00A1DE',
              confirmButtonText: 'Continuar',
              allowOutsideClick: false
            })
          return false;
        }
        else if (regex.test(result.value) == true) {
          this.emailUser = result.value;
          let reponse = this.validateEmail(this.emailUser);
          this.notifyMessage = "Se le notificará electrónicamente al correo registrado";
          // this.spinner.hide();
          if (this.isClient == true) {
            this.back = true;
            this.send = false;
            this.hideNextButton = true;
          }
          else {
            this.back = true;
            this.send = true;
            this.hideNextButton = false;
          }
          this.messageNotificationIcon = false;
          this.emailUser = result.value;
        }
      }
      else {
        var acepta = document.getElementById('inlineRadio1');
        var noAcepta = document.getElementById('inlineRadio2');
        this.messageNotificationIcon = true;
        // this.spinner.hide();
        Swal.fire(
          {
            title: 'Correo de notificación',
            text: 'Por favor ingrese su correo electrónico',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#00A1DE',
            confirmButtonText: 'Continuar',
            allowOutsideClick: false
          })

        return false
      }
    })
  }

  async evaluateEmail(email, valid) {
    var regex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    if (valid == null) {
      this.messageNotificationIcon = true;
      Swal.fire(
        {
          title: 'Correo de notificación',
          text: 'Ha ocurrido un error. Contácte a soporte por favor.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      return true;
    }
    else if (valid == "false") {
      this.messageNotificationIcon = true;
      Swal.fire(
        {
          title: 'Correo de notificación',
          icon: 'warning',
          text: 'El correo ingresado no es válido',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      return false;
    }
    else if (regex.test(email) == true && this.emailValid == "true") {

      this.notifyMessage = "Se le notificará electrónicamente al correo registrado";
      this.back = true;
      this.send = false;
      this.emailUser = email;
      this.hideNextButton = true;
      this.messageNotificationIcon = false;
      Swal.fire(
        {
          title: 'Correo de notificación',
          text: 'Se registró correctamente el correo electrónico',
          icon: 'success',
          html: '<b>' + this.emailUser + '</b>',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      return true;
    }

  }
  async validateEmail(data: any) {
    this.emailValidatorService.emailValidate(data).subscribe(
      response => {
        let data = response;

        this.emailValid = data.validMailbox;

        this.evaluateEmail(data.to, this.emailValid)
        // this.spinner.hide();
      },
      err => {
        Swal.fire({
          title: "Error de servicio",
          text: "Respuesta con error del servicio de correo",
          icon: 'info',
          allowOutsideClick: false
        });
        return false
      });

  }
  //OSIGNERMIN
  /*Lista de motivos */
  reasonListOsi: Basic<string>[] = [];
  /*Lista de submotivos */
  subReasonListOsi: ComplaintSubReason[] = [];
  /*Lista de items del recibo seleccionado */
  billItemList: CheckableItem<BillItem>[] = [];
  /*Lista de códigos de submotivos que emplean la sección de recibos */
  billSubReasonCodeList: string[] = ['Z014', 'Z015', 'Z016', 'Z018', 'Z019', 'Z020', 'Z023'];

  public suReasonName: string;
  public searchActivated: boolean = true;

  public reasonCode: string;
  public subReasonDescCode: string;

  public subReasonCode: string;
  public iconDescription: boolean = true;
  contrastConfirm: boolean;
  availableYearList: Basic<string>[] = [];

  public difRoundedList: any = [];
  public totalSum: any;
  public blockingList: any = [];
  public conceptList: any = [];

  public emDate: any;
  public ammountList: any = [];
  public importSum: any;
  public billModal: any;
  public billData: boolean;
  public listToSend: any = [];
  public listToView: any = [];
  public finalSum: any;
  public checkBoxList: any = [];
  public finalImport: any;

  public consolidateClaim: boolean = true;
  public registerNewClaim: boolean = true;
  public statusCheckBoxList: boolean = false;

  monthList: Basic<string>[] = [{ code: '01', description: 'Enero' },
  { code: '02', description: 'Febrero' },
  { code: '03', description: 'Marzo' },
  { code: '04', description: 'Abril' },
  { code: '05', description: 'Mayo' },
  { code: '06', description: 'Junio' },
  { code: '07', description: 'Julio' },
  { code: '08', description: 'Agosto' },
  { code: '09', description: 'Septiembre' },
  { code: '10', description: 'Octubre' },
  { code: '11', description: 'Noviembre' },
  { code: '12', description: 'Diciembre' }];

  public reasonNameList: Array<any> = [
    { code: 'G002', description: 'El contrato de suministro' },
    { code: 'G003', description: 'Corte y reconexión del servicio' },
    { code: 'G004', description: 'La facturación de mi recibo' },
    { code: 'G006', description: 'La habilitación del servicio de gas' },
    { code: 'G001', description: 'El medidor' },
    { code: 'G007', description: 'Las obras externas o el desmonte' },
    { code: 'G008', description: 'La obtención del suministro' },
    { code: 'G005', description: 'La deuda o el pago' },
  ];
  public subReasonNameList: Array<any> = [
    { code: 'Z001', description: 'Tengo problemas con la caja de mi medidor (Tapa caí­da, tapa abierta, visor caí­do, etc).' },
    { code: 'Z002', description: 'Tengo problemas con la ubicación de mi medidor (El medidor afecta al vecino,  dificulta la modificación del predio, etc).' },
    { code: 'Z003', description: 'Tengo problemas con mi medidor (Contómetro no gira, números de contómetro tienen problemas al girar).' },
    { code: 'Z004', description: 'Aprobaron mi contrato y no se volvieron a contactar/Hubo cambios en las condiciones iniciales del contrato.' },
    { code: 'Z005', description: 'Me cortaron el servicio sin tener deuda actual.' },
    { code: 'Z006', description: 'Me cortaron el servicio en mi revisión quinquenal por equivocación.' },
    { code: 'Z007', description: 'He solicitado la reconexión de mi servicio luego de mi solicitud de suspensión de servicio.' },
    { code: 'Z008', description: 'Ya pagué mi deuda y no han reconectado mi servicio.' },
    { code: 'Z009', description: 'Aún no reconectan mi servicio después de una revisión quinquenal o emergencia.' },
    { code: 'Z010', description: 'Aún no suspenden el servicio de gas natural que solicité.' },
    { code: 'Z011', description: 'Aún no realizan el retiro de mi medidor y tuberí­a de conexión.' },
    { code: 'Z012', description: 'Aún no realizan el retiro de mi medidor.' },
    { code: 'Z013', description: 'Aún no realizan el retiro de mi tuberí­a de conexión.' },
    { code: 'Z014', description: 'No estoy de acuerdo con el cobro/monto de facturación de cargos fijos (Transporte y distribución y/o categorí­a tarifaria).' },
    { code: 'Z015', description: 'No estoy de acuerdo con el cobro/monto del corte y reconexión por mantenimiento quinquenal.' },
    { code: 'Z016', description: 'No estoy de acuerdo con el cobro/monto del corte y reconexión del servicio.' },
    { code: 'Z017', description: 'El recibo demora en llegar / No me ha llegado mi recibo.' },
    { code: 'Z018', description: 'He verificado mi medidor y el consumo es cercano a la "Lectura actual" de mi recibo, pero me parece elevado.' },
    { code: 'Z019', description: 'No estoy de acuerdo con el cobro/monto del financiamiento Bonogas.' },
    { code: 'Z020', description: 'He verificado mi medidor y el consumo es menor a la "Lectura actual" de mi recibo.' },
    { code: 'Z021', description: 'Vivo en otro predio y le llega una carta o aviso a otra persona.' },
    { code: 'Z022', description: 'Pagué mi deuda y me llegó carta o aviso de corte de servicio.' },
    { code: 'Z023', description: 'No visualizo mi pago/ lo veo duplicado.' },
    { code: 'Z024', description: 'Hay redes externas en la calle donde vivo y se están demorando en  habilitar mi servicio .' },
    { code: 'Z025', description: 'No hay redes externas en la calle donde vivo y se están demorando en habilitar mi servicio.' },
    { code: 'Z026', description: 'Solicito la conexión pendiente de mi artefacto y se están demorando en atenderla.' },
    { code: 'Z027', description: 'La construcción de redes externas para el Gas natural ha afectado otros servicios públicos.' },
    { code: 'Z028', description: 'Mal acabado o demora en la reparación de la pista.' },
    { code: 'Z029', description: 'Han dejado desmonte en la ví­a pública.' },
    { code: 'Z033', description: 'El recorrido de redes externas están afectandome.' },
    { code: 'Z034', description: 'Se están demorando en la respuesta a la solicitud de factibilidad de suministro.' },
    { code: 'Z035', description: 'No estoy de acuerdo con el resultado de solicitud de factibilidad de suministro.' },
    { code: 'Z036', description: 'Firmé mi contrato de suministro de Gas natural y aún no ha sido aprobado.' }
  ];

  async clearBoxes() {

    for (let i = 0; i < this.ammountList.length; i++) {
      this.ammountList[i] = '';

    }
    this.totalSum = 0.00;


    this.clearCheckBoxes();
    this.consolidateClaim = true;
    this.registerNewClaim = true;
    return false;
  }

  async cleanRows() {

    this.listToView = [];
    this.listToSend = [];
    this.finalImport = 0.00;
  }

  async clearCheckBoxes() {

    for (let i = 0; i < this.checkBoxList.length; i++) {
      this.checkBoxList[i] = false;

    }
  }



  autoSumElements() {

    for (let i = 0; i < this.conceptList.length; i++) {
      //CPAREDES COMPARACION DE CAMPOS
      let saldo = parseFloat(this.conceptList[i].Importe);
      let saldoIniciado = parseFloat(this.ammountList[i]);
      if (saldo < saldoIniciado) {
        Swal.fire(
          {
            title: 'Información',
            text: 'Por favor. Ingresa un valor menor al importe',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#00A1DE',
            confirmButtonText: 'Continuar',
            allowOutsideClick: false
          })
        this.ammountList[i] = "";
        return false;
      }
    }

    for (let i = 0; i < this.ammountList.length; i++) {
      if (this.ammountList[i] == null || this.ammountList[i] == "") this.ammountList[i] = 0.00;
    }

    let total = this.ammountList.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
    let rounded = parseFloat(total).toFixed(2);
    this.totalSum = rounded;
    if (this.totalSum != 0) {
      this.consolidateClaim = false
      this.registerNewClaim = false
    }
    else {
      this.consolidateClaim = true
      this.registerNewClaim = true
    }
  }


  fillYearList() {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 7; i++) {
      this.availableYearList.push({ code: (currentYear - i).toString(), description: (currentYear - i).toString() });
    }
  }
  getDetailedBill() {

    if (this.formGroup.get('bill').get('month').value != null && this.formGroup.get('bill').get('year').value) {
      this.billService.getDetailedBill(this.formGroup.get('client').get('code').value,
        this.formGroup.get('bill').get('month').value,
        this.formGroup.get('bill').get('year').value,
      ).subscribe(response => {

        if (response.valid) {
          this.billItemList = response.data.itemList.map((item => new CheckableItem<BillItem>(item)));
          this.formGroup.get('bill').get('number').patchValue(response.data.number);
          this.searchActivated = false;
        }
        else if (response.valid && response.warning) {
          this.billItemList = [];
          this.formGroup.get('bill').get('number').patchValue(null);
          Swal.fire('Información', response.message, 'warning');
          this.searchActivated = true;
        }
        else {
          this.billItemList = [];
          this.formGroup.get('bill').get('number').patchValue(null);
        }
      });
    }
  }
  statusBox() {
    //Igualar a cero los valores de las cajas de texto que no tengan valor
    for (let i = 0; i < this.checkBoxList.length; i++) {
      if (this.ammountList[i] == null || this.ammountList[i] == "") this.ammountList[i] = 0.00
      if (this.checkBoxList[i] == false) this.ammountList[i] = 0.00
      for (let i = 0; i < this.checkBoxList.length; i++) {
        if (this.conceptList[i].DesConcepto == 'Reconexión de Servicio' ||
          this.conceptList[i].DesConcepto == 'Desconexión de Servicio') {
          if (this.checkBoxList[i] == false) {
            this.ammountList[i] = 0.00
          }
          else {
            this.ammountList[i] = this.conceptList[i].Importe;
          }
        }
        else {
          //console.log("Se salió xD")
        }
      }
    }
    //Sumar todos los valores de las cajas de texto digitadas
    let tot = this.ammountList.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
    let round = parseFloat(tot).toFixed(2);
    if (round == 'NaN' || round == 'null') {
      round = '0';
    }
    this.totalSum = round;
    if (this.totalSum != "0.00") {
      this.consolidateClaim = false
      this.registerNewClaim = false
    }
    else {
      this.consolidateClaim = true
      this.registerNewClaim = true
    }
  }
  async invokeModal(contenido) {

    if (this.conceptList.length == 0) {
      Swal.fire(
        {
          title: 'Información',
          text: 'No se han encontrado conceptos',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      return false;
    }
    else {
      this.modal.open(contenido, { size: 'lg' });
    }

  }


  showData(modal) {
    let total = this.ammountList.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
    let rounded = parseFloat(total).toFixed(2);

    modal.dismiss();
    this.billData = false;
    this.finalSum = rounded;
    //Lista para la grilla
    let data: any = {};
    data.date = this.blockingList.FechaEmision;
    data.dateFormat = String(data.date).substring(6, 8) + "/" + String(data.date).substring(4, 6) + "/" + String(data.date).substring(0, 4);
    data.documentNumber = this.blockingList.NroDocumentoOficial;
    data.total = this.finalSum;
    this.listToView.push(data);

    //Para el servicio

    for (let i = 0; i < this.checkBoxList.length; i++) {
      let checked = this.checkBoxList[i];
      if (checked == true) {
        let data: any = {};
        data.Locutor = this.blockingList.InterloculorComercial;
        data.documentNumber = this.blockingList.NroDocumentoOficial;
        data.Year = this.blockingList.PE_Concepto[i].AñoEjercicio;
        data.Month = this.blockingList.PE_Concepto[i].Mes;
        data.Date = this.blockingList.FechaEmision;
        data.DateHist = this.blockingList.FechaVencimiento;
        data.ConceptCode = this.blockingList.PE_Concepto[i].CodConcepto;
        data.DesConcept = this.blockingList.PE_Concepto[i].DesConcepto;
        data.Import = this.ammountList[i];
        data.Moneda = this.blockingList.PE_Concepto[i].Moneda;
        this.listToSend.push(data);
      }

      // if (this.formGroup.get('subReason').value == "Z018" || this.formGroup.get('subReason').value == "Z065" ||
      // this.formGroup.get('subReason').value == "Z015" || this.formGroup.get('subReason').value == "Z016" ||
      // this.formGroup.get('subReason').value == "Z014" || this.formGroup.get('subReason').value == "Z019" ||this.formGroup.get('subReason').value == "Z020")
      // {
      //   let round: any = {};
      //   round.Locutor = this.blockingList.InterloculorComercial;
      //   round.documentNumber = this.blockingList.NroDocumentoOficial;
      //   round.Year = this.formGroup.get('bill').get('year').value;
      //   round.Month = this.formGroup.get('bill').get('month').value;
      //   round.Date = this.blockingList.FechaEmision;
      //   round.DateHist = this.blockingList.FechaVencimiento;
      //   round.ConceptCode = this.blockingList.PE_Concepto[i].CodConcepto;
      //   round.DesConcept = this.blockingList.PE_Concepto[i].DesConcepto;
      //   round.Import = 0.02;
      //   this.listToSend.push(round);
      //   console.log("Se insertó el concepto adicional")
      // }
      // else
      // {
      //   console.log("no se insertó el parámetro adicional")
      // }
    }
    if (this.formGroup.get('subReason').value == "Z018" ||
      this.formGroup.get('subReason').value == "Z015" || this.formGroup.get('subReason').value == "Z016" ||
      this.formGroup.get('subReason').value == "Z014" || this.formGroup.get('subReason').value == "Z019" || this.formGroup.get('subReason').value == "Z020") {
      for (let i = 0; i < this.difRoundedList.length; i++) {
        let roundedData: any = {};
        roundedData.Locutor = this.blockingList.InterloculorComercial;
        roundedData.documentNumber = this.blockingList.NroDocumentoOficial;
        roundedData.Year = this.formGroup.get('bill').get('year').value;
        roundedData.Month = this.formGroup.get('bill').get('month').value;
        roundedData.Date = this.blockingList.FechaEmision;
        roundedData.DateHist = this.blockingList.FechaVencimiento;
        roundedData.ConceptCode = this.difRoundedList[i].CodConcepto;
        roundedData.DesConcept = this.difRoundedList[i].DesConcepto;
        roundedData.Import = this.difRoundedList[i].Importe;
        roundedData.Moneda = this.difRoundedList[i].Moneda;
        //  roundedDate.Import = parseFloat(this.difRoundedList[i].Importe).toFixed(2)
        //console.log("List para enviar al back", this.listToSend)
        this.listToSend.push(roundedData)
        //console.log("Lista para enviar con el redondeo",this.listToSend) 

      }
    }

    let importFin: any = [];
    for (let i = 0; i < this.listToView.length; i++) {
      importFin.push(this.listToView[i].total)
    }
    let LastSumImport = importFin.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
    let importFinalRounded = parseFloat(LastSumImport).toFixed(2);

    this.finalImport = importFinalRounded;
    this.difRoundedList = [];
    this.checkBoxList = [];
    this.clearBoxes();
    //this.finalSum = this.totalSum;
  }


  openModal(contenido) {

    let request = new ClaimsBlocking();
    request.CodMotivo = this.reasonCode;
    request.CodSubMotivo = this.subReasonCode;
    request.PeriodoAnno = this.formGroup.get('bill').get('year').value;
    request.PeriodoMes = this.formGroup.get('bill').get('month').value;
    //request.PeriodoAnno = "2017";
    //request.PeriodoMes = "05";
    request.Interlocutor = "";
    request.Contrato = "";
    request.CtaContrato = this.formGroup.get('client').get('code').value;
    //request.CtaContrato = "640159";
    request.UsuarioServicio = "UsrCalidda2021";
    request.ClaveServicio = "Calidd@2021";
    if (request.PeriodoAnno == null || request.PeriodoMes == null) {
      Swal.fire(
        {
          title: 'Información',
          text: 'Por favor seleccione el mes y el aí±o para la búsqueda',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      return false;
    }
    else {
      if (request) {
        this.complaintService.getInfo(request).subscribe(
          res => {

            this.blockingList = res;
            this.conceptList = this.blockingList.PE_Concepto;

            if (this.conceptList.length != 0) {
              for (let i = 0; i < this.conceptList.length; i++) {
                if (this.conceptList[i].CodConcepto == '08000010') {
                  this.difRoundedList.push(this.conceptList[i]);
                  this.conceptList = this.conceptList.filter(item => item != this.conceptList[i]);
                }
              }
            }

            this.invokeModal(contenido);

            let date = this.blockingList.FechaEmision;
            var anio = String(date).substring(0, 4);
            var mes = String(date).substring(4, 6);
            var dia = String(date).substring(6, 8);
            let nuevaFecha = dia + "/" + mes + "/" + anio;
            let newFormat = moment(nuevaFecha, 'DD/MM/YYYY')
            newFormat.locale('es');
            let newDate = newFormat.format('DD [de] MMMM [del] YYYY');
            this.emDate = newDate
            this.billModal = this.formGroup.get('bill').get('number').value;
            //Para autosumar los importes
            let ImportList: any = [];
            for (let i = 0; i < this.conceptList.length; i++) {
              ImportList.push(parseFloat(this.conceptList[i].Importe))
            }

            let total = ImportList.map(c => parseFloat(c)).reduce((a, b) => a + b, 0.00);
            let rounded = parseFloat(total).toFixed(2);
            this.importSum = rounded;

          },
          err => {
            //console.log("error del servicio de bloqueo de reclamos", err)
          });


      }
    }

  }
  listComplaintReasons() {
    this.masterService.listComplaintReasons().subscribe(response => {

      this.reasonListOsi = response.data;
      if (!this.isClient) {
        let noClientComplaintList = ["G007", "G008"];
        this.reasonListOsi = this.reasonListOsi.filter(x => noClientComplaintList.includes(x.code));
      }
      this.reasonListOsi.sort((a, b) => {
        const descriptionA = a.description.toLowerCase(), descriptionB = b.description.toLowerCase();
        if (descriptionA < descriptionB) { return -1; } else if (descriptionA > descriptionB) { return 1; } else { return 0; }
      });
    });

  }
  listComplaintSubReason() {
    this.suReasonName = "";
    this.masterService.listComplaintSubReasons(this.formGroup.get('reason').value).subscribe(response => {
      //Validación de lista de submotivos para no clientes
      if (this.isClient == false) {
        this.subReasonListOsi = response.data;

        //Validación para no cliente

        const newSubReasonList = [];
        for (var item of this.subReasonListOsi) {
          if (item.code == "Z032") {
            newSubReasonList.push(item);
          }
        }
        var obrasexternas = this.subReasonListOsi.find(x => x.code == "Z032")

        if (obrasexternas != null) {
          this.subReasonListOsi = newSubReasonList
        }
        else {
          this.subReasonListOsi = response.data
        }

      }
      //console.log("Lista de submotivos",this.subReasonList)
      //this.subReasonList = response.data;

      this.masterService.listComplaintSubReasons(this.formGroup.get('reason').value).subscribe(response => {
        //VALIDAR mensajeria
        this.subReasonListOsi = response.data;
        this.subReasonListOsi.sort((a, b) => {
          const descriptionA = a.description.toLowerCase(), descriptionB = b.description.toLowerCase();
          if (descriptionA < descriptionB) { return -1; } else if (descriptionA > descriptionB) { return 1; } else { return 0; }
        });
        this.formGroup.get('subReason').patchValue(null);
        this.showBillSection = false;
        this.cleanBillSection();
      });
      //Descripciones del motivo y submotivo
      //this.reasonDescCode = this.reasonCode;
      //let reasonN = this.reasonNameList.find(x => x.code == this.reasonDescCode);

      //this.reasonName = reasonN.description;
    });

  }



  subReasonChangedOsi() {
    this.showBillSection = this.billSubReasonCodeList.includes(this.formGroup.get('subReason').value);
    this.searchActivated = true;
    if (this.showBillSection) {
      this.cleanBillSection();
      this.formGroup.get('bill').get('number').setValidators(Validators.required);
      this.formGroup.get('bill').get('month').setValidators(Validators.required);
      this.formGroup.get('bill').get('year').setValidators(Validators.required);
      this.formGroup.updateValueAndValidity();
    } else {
      this.formGroup.get('bill').get('number').setValidators(null);
      this.formGroup.get('bill').get('month').setValidators(null);
      this.formGroup.get('bill').get('year').setValidators(null);
    }
    this.formGroup.get('bill').get('number').updateValueAndValidity();
    this.formGroup.get('bill').get('month').updateValueAndValidity();
    this.formGroup.get('bill').get('year').updateValueAndValidity();
    //Descripciones del motivo y submotivo
    this.subReasonDescCode = this.subReasonCode;
    let subReasonN = this.subReasonNameList.find(x => x.code == this.subReasonDescCode);

    if (subReasonN != null) {
      this.suReasonName = subReasonN.description;
      this.iconDescription = false;
    }
    else {
      this.suReasonName = '';
      this.iconDescription = true;
    }

    if ((this.formGroup.get('subReason').value == "Z018" || this.formGroup.get('subReason').value == "Z020")) {


      const meterReciboDigital = this.matDialog.open(MeterReciboDigitalComponent, {
        disableClose: true,
        width: '878px', // Ancho del diálogo
        height: '1130px', // Alto del diálogo
      });

      
      meterReciboDigital.afterClosed().subscribe(response => {
    
        const meterContrastAd = this.matDialog.open(MeterContrastAdComponent, {
          disableClose: true
        });
        meterContrastAd.afterClosed().subscribe(response => {
          this.contrastConfirm = response;
        });
       
      });
       
    }

  }

  cancel() {
    if (this.bandera == true || this.authService.IsStandaloneModule() && this.isClient == true) {
      this.authService.logOut();

    }
    else if (this.bandera == false && this.authService.IsStandaloneModule() && this.isClient == false) {
      window.location.reload();
      window.location.href = this.environmentService.portalWebUrl + "atencion-al-cliente/registrar-reclamos#seccion?reg=1";
      //Descomentar para producción
      //window.location.href =  this.environmentService.portalWebUrl + "atencion-al-cliente/registrar-reclamos#seccion";  
    }
    else {

      //console.log("bandera",this.bandera)
      this.router.navigate(['/ofivirtual']);
    }
  }
}